import React from 'react';

const PaymentConfirmationModal = ({ isOpen, status, paymentDetails, onRetry, onClose, message, onDownloadReceipt }) => {
    if (!isOpen) return null;

    const modalStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1050
    };

    const cardStyle = {
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '30px',
        maxWidth: '650px',
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
    };

    return (
        <div style={modalStyle}>
            <div style={cardStyle}>
                {status === 'PENDING' && (
                    <div className="d-flex flex-column align-items-center">
                        <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <h4 className="fw-bold">Verifying Payment</h4>
                        <p className="text-muted">Please wait while we verify your transaction. Do not refresh or close this page.</p>
                    </div>
                )}

                {status === 'SUCCESS' && (
                    <div className="d-flex flex-column align-items-center">
                        <div className="mb-3">
                            <i className="fas fa-check-circle text-success" style={{ fontSize: '4rem' }}></i>
                        </div>
                        <h4 className="fw-bold text-success mb-2">Booking Confirmed!</h4>

                        <div className="alert alert-light border w-100 text-start">
                            <h5 className="fw-bold text-center text-primary mb-3">Divyakshetra Hariharapura</h5>
                            <p className="mb-2">Your Room booking is confirmed in  <strong>{paymentDetails?.building_name || '...'}</strong>.</p>

                            <p className="mb-1"><strong>Check-in Date:</strong> {paymentDetails?.checkin_date}</p>
                            <p className="mb-1"><strong>Checkout Date:</strong> {paymentDetails?.checkout_date}</p>
                            <p className="mb-3 text-muted small">Booked on {paymentDetails?.booking_date}</p>

                            <h5 className="fw-bold">Amount received: Rs. {paymentDetails?.amount || 0}/-</h5>

                            <div className="mt-3">
                                <strong>Receipt: </strong>
                                <button className="btn btn-link p-0 text-decoration-none" onClick={onDownloadReceipt}>
                                    Download <i className="fas fa-download ms-1"></i>
                                </button>
                            </div>
                        </div>

                        <div className="text-center mt-2 mb-3">
                            <p className="mb-1 fw-bold text-dark">*For more updates, please Join our WhatsApp Channel* :</p>
                            <a href="https://whatsapp.com/channel/0029Vb5hOsPId7nDh5SDJO1Z" target="_blank" rel="noopener noreferrer" className="text-success fw-bold text-decoration-none">
                                <i className="fab fa-whatsapp me-2"></i>Join WhatsApp Channel
                            </a>
                        </div>

                        <div className="d-flex gap-2 w-100 mt-2">
                            <button className="btn btn-primary flex-grow-1" onClick={onClose}>
                                Done
                            </button>
                        </div>
                    </div>
                )}

                {status === 'FAILED' && (
                    <div className="d-flex flex-column align-items-center">
                        <div className="mb-3">
                            <i className="fas fa-times-circle text-danger" style={{ fontSize: '4rem' }}></i>
                        </div>
                        <h4 className="fw-bold text-danger mb-3">Payment Failed</h4>
                        <p className="text-muted mb-4">{message || "We couldn't verify your payment. If money was deducted, it will be refunded automatically."}</p>
                        <div className="d-flex gap-2 w-100">
                            <button className="btn btn-secondary flex-grow-1" onClick={onClose}>
                                Close
                            </button>
                            <button className="btn btn-danger flex-grow-1" onClick={onRetry}>
                                Retry Payment
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentConfirmationModal;
